<template>

  <div class=" activity-button box" :class="[name]">
    <button class="btn bg" v-on:click="clicked">
      <img src="@/assets/image/platform/activities/bb_button_activity.svg" alt="">
      <BG style="position: absolute; left: 0" :class="pulseButton? 'pulse' : ''"/>
      <Fade style="position: absolute; left: 0" :class="pulseButton? 'pulse-soft' : ''"/>
    </button>

    <div style="width: 190px; height: 160px; display: flex; align-items: center; justify-content: center;"
         v-on:click="clicked" v-hover="onHoverOver">
      <BeweegMeer v-if="name==='more'" class="icon" :class="[name, pulseButton? 'pulse' : '']"
                  v-hover="onHoverOver"></BeweegMeer>
      <BeweegSamen v-if="name==='together'" class="icon" :class="[name, pulseButton? 'pulse' : '']"
                   v-hover="onHoverOver"></BeweegSamen>
      <BeweegSlim v-if="name==='smart'" class="icon" :class="[name, pulseButton? 'pulse' : '']"
                  v-hover="onHoverOver"></BeweegSlim>
      <BeweegTussendoor v-if="name==='impulse'" class="icon" :class="[name, pulseButton? 'pulse' : '']"
                        v-hover="onHoverOver"></BeweegTussendoor>
    </div>


    <!--<div class="icon" :class="[name, pulseButton? 'pulse' : '']"></div>-->

    <p class="title" v-hover="onHoverOver">{{ questTypeToString(name) }}</p>

    <button v-show="startedActivities.length > 0" class="btn notification" v-on:click="notificationClicked">
      <NotificationIcon :class="questTypeClass(name)+'-notification'"/>

      <span v-hover="onHoverOverNotification">{{ startedActivities.length }}</span>
    </button>
    <HoverInfo :show="hoveringOverNotification" :content="startedActivities.length + ' opdracht(en) niet afgerond'"
               :offset-y="12" :offset-x="12"></HoverInfo>
    <HoverInfo v-if="name==='more'" :show="hoveringOver"
               :content="'Klik hier om alle opdrachten van de categorie \'Beweeg Meer\' te zien'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo v-if="name==='smart'" :show="hoveringOver"
               :content="'Klik hier om alle opdrachten van de categorie \'Beweeg Slim\' te zien'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo v-if="name==='together'" :show="hoveringOver"
               :content="'Klik hier om alle opdrachten van de categorie \'Beweeg Samen\' te zien'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo v-if="name==='impulse'" :show="hoveringOver"
               :content="'Klik hier om alle opdrachten van de categorie \'Beweeg Tussendoor\' te zien'" :offset-y="12"
               :offset-x="12"></HoverInfo>


  </div>

</template>

<script>

import NotificationIcon from "@/assets/image/platform/activities/bb_notification.svg?inline";
import BeweegMeer from "@/assets/image/platform/activities/bb_icon-beweeg_meer.svg?inline";
import BeweegSlim from "@/assets/image/platform/activities/bb_icon-beweeg_slim.svg?inline";
import BeweegSamen from "@/assets/image/platform/activities/bb_icon-beweeg_samen.svg?inline";
import BeweegTussendoor from "@/assets/image/platform/activities/bb_icon-beweeg_tussendoor.svg?inline";


import BG from "@/assets/image/platform/activities/bb_button_activity_highlight.svg?inline";
import Fade from "@/assets/image/platform/activities/bb_button_overlay.svg?inline";

import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "ActivityButton",
  components: {HoverInfo, BG, Fade, NotificationIcon, BeweegMeer, BeweegSamen, BeweegSlim, BeweegTussendoor},
  mixins: [ QuestTypeHelper ],
  emits: [ "clicked", "notificationClicked", "nextPlannedActivityClicked" ],
  props: {
    name: String,
    show: Boolean,
    startedActivities: Array,
    plannedActivities: Array,
  },
  data()
  {
    return {
      pulseButton: false,
      hoveringOverNotification: false,
      hoveringOver: false,
    }
  },
  watch: {
    plannedActivities: {
      handler()
      {
        this.setupButton();
      },
    },
    show: {
      handler()
      {
        this.setupButton();
      },
    },
  },
  computed: {},
  methods: {

    clicked()
    {
      if (this.plannedActivities.length > 0)
      {
        this.$emit("nextPlannedActivityClicked", this.name);
      }
      else
      {
        this.$emit("clicked", this.name);
      }
    },

    setupButton()
    {
      let that = this;

      if (this.plannedActivities.length > 0)
      {
        this.$el.querySelectorAll('.activityButtonColorOutline').forEach(function(el)
        {
          el.setAttribute('style', 'fill:' + that.questTypeColor(that.name));
        });
        this.$el.querySelectorAll('.color-change').forEach(function(el)
        {
          el.setAttribute('style', 'fill:' + that.questTypeColor(that.name));
        });
        that.pulseButton = true;
        
      }
      else
      {
        this.$el.querySelectorAll('.activityButtonColorOutline').forEach(function(el)
        {
          el.setAttribute('style', 'fill: rgba(0,0,0,0)');
        });
        this.$el.querySelectorAll('.color-change').forEach(function(el)
        {
          el.setAttribute('style', 'fill:' + 'rgba(0,0,0,0)');
        });

        that.pulseButton = false;
      }

      if (this.$el.querySelector('.notificationCenter') !== null)
      {
        this.$el.querySelector('.notificationCenter').setAttribute('style', 'fill:' + this.questTypeColor(this.name));
      }
    },

    notificationClicked()
    {
      this.$emit("notificationClicked", this.name);
    },
    onHoverOverNotification(state) {
      this.hoveringOverNotification = state;
    },
    onHoverOver(state) {
      this.hoveringOver = state;
    }
  },
  mounted()
  {
    this.$nextTick(function()
    {

      let that = this;
      this.$el.querySelectorAll('.bottom-light').forEach(function(el)
      {
        el.setAttribute('style', 'fill:' + that.questTypeColor(that.name));
      });


    });
  },
  created()
  {
  }
}

</script>

<style lang="scss" scoped>

.activity-button {
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10%;
  position: relative;
  pointer-events: auto;

  &:hover {
    cursor: pointer;
  }

  &.more .cls-7 {
    fill: rgb(255, 90, 49);
  }

  &.smart .cls-7 {
    fill: rgb(0, 185, 255);
  }

  &.together .cls-7 {
    fill: rgb(159, 220, 96);
  }

  &.impulse .cls-7 {
    fill: rgb(253, 132, 255);
  }

  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
    padding: 0;

    .pulse {
      opacity: 100%;
      animation: pulseAnim 1s infinite;
    }

    .pulse-soft {
      opacity: 80%;
      animation: pulseAnimSoft 1s infinite;
    }
  }

  @keyframes pulseAnim {
    0% {
      opacity: 10%;
    }

    50% {
      opacity: 100%;
    }

    100% {
      opacity: 10%;

    }
  }

  @keyframes pulseAnimSoft {
    0% {
      opacity: 10%;
    }

    50% {
      opacity: 60%;
    }

    100% {
      opacity: 10%;

    }
  }

  @keyframes scaleAnim {
    0% {
      transform: scale(0.80);
    }

    50% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.80);
    }
  }

  .icon {
    margin-top: 15px;
    width: 65%;
    height: 65%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: transparent;
    z-index: 1;
    pointer-events: none;

    &.pulse {
      transform: scale(1);
      animation: scaleAnim 1s infinite;
    }
  }

  .title {
    position: relative;
    top: -10px;
    font-size: min(3vw, 3vh);
    line-height: 0.9;
    font-weight: bold;
    color: white;
    text-align: center;
    z-index: 1;
    pointer-events: none;
  }

  .smart {
    .activityButtonColorOutline {
      fill: $activity-orange;
    }
  }

  .together {
    .activityButtonColorOutline {
      fill: $activity-orange;
    }
  }

  .impulse {
    .activityButtonColorOutline {
      fill: $activity-orange;
    }
  }

  .notification {
    position: absolute;
    top: -5%;
    right: -5%;
    width: 30%;
    height: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;

    svg {
      position: absolute;
      z-index: -1;
    }

    span {
      font-weight: bold;
      color: white;
      font-size: min(4vh, 4vw);
    }
  }

  .together-notification {
    background-image: $notification-icon;

    .notification-center {
      fill: $activity-orange;
    }
  }

  //for svg
  .cls-1 {
    isolation: isolate;
  }

  .cls-2 {
    fill: #453251;
  }

  .cls-2, .cls-6 {
    opacity: 0.9;
  }

  .cls-3 {
    mix-blend-mode: screen;
    fill: url(#Áåçûìÿííûé_ãðàäèåíò_5);
  }

  .cls-4 {
    opacity: 0.1;
  }

  .cls-13, .cls-5 {
    fill: none;
    stroke-miterlimit: 10;
  }

  .cls-5 {
    stroke: #fff;
    stroke-width: 2.02px;
  }

  .cls-7 {
    fill: #fff;
  }

  .cls-8 {
    opacity: 0.4;
  }

  .cls-9 {
    fill: #98b8ff;
  }

  .cls-10 {
    fill: #705683;
  }

  .cls-11 {
    fill: #907c9f;
  }

  .cls-12 {
    fill: #4f6abd;
  }

  .cls-13 {
    stroke: #816a92;
    stroke-width: 1.01px;
  }

  .cls-14 {
    fill: #816a92;
    opacity: 0.5;
  }
}

.more-color .notification-center {
  fill: $activity-orange;
}

.smart-color .notification-center {
  fill: $activity-orange;
}

.together .notification-center {
  fill: $activity-orange;
}

.impulse-color .notification-center {
  fill: $activity-orange;
}

.more .activityButtonColorOutline {
  fill: $activity-orange;
}


</style>